import DragonSymbolSkin from './DragonSymbolSkin'
import SpriteSymbol from './SpriteSymbol'
import Symbol from './Symbol'
import SymbolSkin from './SymbolSkin'
import TwoSymbols from './TwoSymbols'
export  function  getSymbol(id, reelSettings) {
  switch (reelSettings.type) {
    case 'volatilehot': return new SpriteSymbol(id, reelSettings)
    case 'twoSymbols': return new TwoSymbols(id, reelSettings)
    case 'symbolSkin': return new SymbolSkin(id, reelSettings)
    case 'dragonSymbolSkin': return new DragonSymbolSkin(id, reelSettings)
    default: return  new Symbol(id, reelSettings)
  }

}
